export default {
    Comment: 'Opmerking'
}
